import importerReducers from 'src/modules/shared/importer/importerReducers';
import actions from 'src/modules/place/importer/placeImporterActions';

export default importerReducers(actions);
